import React, {useEffect, useState} from "react";
import {ResponseEditor} from "../ResponseEditor";
import {RightChatBubbleView} from "../../../../designSystem/components/ChatBubbleView";
import {Typography} from "../../../../designSystem/components/Typography";

export const RuleEditor = ({ rule, onChange }) => {
  const [inputValue, setInputValue] = useState<string>(rule?.match?.keywords?.join(', ') || '');

  useEffect(() => {
    if (rule?.match?.keywords) {
      setInputValue(rule.match.keywords.join(', '));
    }
  }, [rule])

  if (!rule) return (
    <div className="text-gray-500">
      請從左側選擇一條規則
    </div>
  )

  const set = (p) => onChange({ ...rule, ...p });
  const setMatch = (p) => onChange({ ...rule, match: { ...rule.match, ...p } });

  return (
    <div className="space-y-3">
      <div className="flex flex-col items-end">
        <div className="flex flex-col gap-3 mb-2">
          <Typography variant="caption" className="text-right">
            關鍵字（多個以逗號分隔）
          </Typography>
          <RightChatBubbleView>
            <input
              className="w-[300px] rounded p-2 text-right"
              value={inputValue}
              onChange={e => {
                setInputValue(e.target.value)
              }}
              onBlur={() => {
                const value = inputValue
                  .split(',')
                  .map(s => s.trim())
                  .filter(Boolean);
                setMatch({keywords: value});
              }}
              placeholder="例如：hi, hello, 哈囉"
            />
          </RightChatBubbleView>
        </div>
        <div className="flex flex-row item-start gap-x-2">
          <div className="flex flex-col">
            <Typography variant="caption">
              優先權（越大越先）
            </Typography>
            <input
              type="number"
              className="w-[100px] border rounded p-2 text-xs"
              value={rule.priority}
              onChange={e => set({priority: Number(e.target.value || 0)})}
            />
          </div>
          <div className="flex flex-col">
            <Typography variant="caption">
              比對類型
            </Typography>
            <select
              className="w-full border rounded p-2 text-xs"
              value={rule.match.type}
              onChange={e => setMatch({type: e.target.value})}
            >
              <option value="exact">完全相符</option>
              <option value="contains">部分相符</option>
            </select>
          </div>
        </div>
      </div>

      <Typography variant="subtitle">
        則自動回覆以下訊息
      </Typography>

      {(rule.responses || []).map((b, i) => (
        <ResponseEditor
          key={i}
          block={b}
          onChange={(nb) => {
            const arr = [...rule.responses];
            arr[i] = nb;
            set({responses: arr});
          }}
          onRemove={() => {
            const arr = [...rule.responses];
            arr.splice(i, 1);
            set({responses: arr});
          }}
        />
      ))}

      <div className="fixed bottom-16 right-16 z-50">
        <button
          onClick={() =>
            set({
              responses: [
                ...(rule.responses || []),
                {type: 'text', payload: {text: ''}},
              ],
            })
          }
          className="
            flex items-center gap-2
            px-10 py-3
            rounded-full
            bg-white
            text-sm font-medium text-gray-700
            shadow-md
            border border-gray-200
            hover:shadow-lg
            hover:bg-gray-50
            active:scale-95
            transition
          "
        >
          <span className="text-ptTeal-100 text-base leading-none">＋</span>
          <span className="text-ptTeal-100">新增回覆訊息</span>
        </button>
      </div>
    </div>
  );
}
